import { render, staticRenderFns } from "./CursoVersionList.vue?vue&type=template&id=496a9b55&scoped=true&"
import script from "./CursoVersionList.vue?vue&type=script&lang=js&"
export * from "./CursoVersionList.vue?vue&type=script&lang=js&"
import style0 from "./CursoVersionList.vue?vue&type=style&index=0&id=496a9b55&lang=scss&scoped=true&"
import style1 from "./CursoVersionList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496a9b55",
  null
  
)

export default component.exports